import shopVideoLakeMinnetonka from './page_assets/shop_video_lake_page.png';
import toolsDashboardImg from './page_assets/tools_imgs/dashboard.png';
import toolsLinkBuilderImg from './page_assets/tools_imgs/link_builder.png';
import toolsMobileAppImg from './page_assets/tools_imgs/mobile_app.png';
import toolsProfileImg from './page_assets/tools_imgs/profile.png';
import toolsVideoImg from './page_assets/tools_imgs/video.png';
import toolsDashboardIcon from './page_assets/tools_icons/dashboard.png';
import toolsLinkBuilderIcon from './page_assets/tools_icons/link.png';
import toolsMobileAppIcon from './page_assets/tools_icons/mobile_app.png';
import toolsProfileIcon from './page_assets/tools_icons/public_profile.png';
import toolsVideoIcon from './page_assets/tools_icons/video.png';
import eyeIcon from './page_assets/value_prop_icons/eye.png';
import moneyIcon from './page_assets/value_prop_icons/money.png';
import trophyIcon from './page_assets/value_prop_icons/trophy.png';

export const omniaBlueValueProp = `When you become an Omnia Blue Ambassador, you expand your reach to a scale not
attainable anywhere else, with the power to reach the right audience at the right
time. A modern version of the traditional in-store demos, your content can be
recorded once and then referenced by anglers over and over again, indefinitely. 
Share your expertise with the community and reap the rewards.`;

export const omniaBlueDisclaimer = `Omnia Fishing retains the right to use content developed by Omnia Blue Ambassadors
during or after participation in the Omnia Blue Program. Some product categories are
excluded from commission earnings. Omnia utilizes a cookie to ensure sale credit on
sales up to seven days after the most recent visit through an affiliate link. Cash
commissions are paid out quarterly, one month after quarter end date to allow for any
potential returns. Quarterly commissions less than $100 will carry over to the next
quarter and will be paid once earnings reach $100. Earnings on the Affiliate Analytics
Dashboard report are close estimates, but not exact earnings.`;

export const omniaBlueTestimonialQuote = `The reporting [analytics dashboard] is broken down to such a detailed level so that
it’s very easy to see which lures or what products got the clicks that drove people to
your website.`;

export const bigCards = [
  {
    title: 'Let Us Help Build Your Audience',
    text: 'Publish once and your content is automatically made available to thousands of anglers through our media library, ecommerce site, personalized newsletter and more. Intelligent tagging ensures it reaches the perfect audience.',
    img: 'https://omnia-fishing.imgix.net/landing_pages_content/omnia_blue_landing_page/phones.png',
    img_alt: 'graphic of phones with Omnia ambassadors',
  },
  {
    title: 'Create Your Way',
    text: 'Bring your videos to Omnia and our shoppable video player will make them actionable through side by side product links. Whether you create brand new or import your existing library, viewers get a direct path to action and you’ll get full credit.',
    img: shopVideoLakeMinnetonka,
    img_alt: 'screen grab of Omnia shoppable video player',
  },
];

export const rewardsAndBenefitsCards = [
  {
    title: 'Earn Money',
    text: 'Blue Ambassadors get rewarded when they help sell products. Each time a shopper uses your published content to discover a product that they purchase, you’ll earn an affiliate cash payment.',
    icon: moneyIcon,
    icon_alt: 'icon of dollar sign',
  },
  {
    title: 'Industry Exposure & Visibility',
    text: 'Our local ambassadors are the stars of the show at Omnia. We love to surface outstanding content that’s relevant to our tens of thousands of active users. Show them you’re the expert in your area of specialization.',
    icon: eyeIcon,
    icon_alt: 'icon of an eye',
  },
  {
    title: 'Prove Your Influence',
    text: 'Our reporting tools pinpoint exactly how often users are interacting with your content, and the behaviors that result. Demonstrate your impact on consumer behavior and back it up with real data.',
    icon: trophyIcon,
    icon_alt: 'icon of a trophy',
  },
];

export const toolsCards = [
  {
    title: 'Shoppable Video Tool',
    text: 'Tag your videos and the relevant products will be presented in a dynamic panel for viewers.',
    img: toolsVideoImg,
    img_alt: 'graphic of shoppable video tool',
    icon: toolsVideoIcon,
    icon_alt: 'play icon',
  },
  {
    title: 'Self-Service Affiliate Link Creator',
    text: 'Create trackable links in a few taps with our link shortener for easy sharing.',
    img: toolsLinkBuilderImg,
    img_alt: 'graphic of link builder tool',
    icon: toolsLinkBuilderIcon,
    icon_alt: 'link icon',
  },
  {
    title: 'Omnia Mobile App',
    text: 'File new fishing reports quickly and efficiently with our mobile app for Apple and Android devices.',
    img: toolsMobileAppImg,
    img_alt: 'graphic of mobile app',
    icon: toolsMobileAppIcon,
    icon_alt: 'mobile phone icon',
  },
  {
    title: 'Professional Public Profile',
    text: 'Show off your content on a dedicated page at Omnia and include your profile and social media links.',
    img: toolsProfileImg,
    img_alt: 'graphic of ambassador profiles',
    icon: toolsProfileIcon,
    icon_alt: 'profile icon',
  },
  {
    title: 'Access to Analytics Dashboard',
    text: 'Get access to easy-to-use reports with graphs, charts, and metrics on your content’s performance.',
    img: toolsDashboardImg,
    img_alt: 'graphic of analytics dashboard',
    icon: toolsDashboardIcon,
    icon_alt: 'graph icon',
  },
];

export const blueAmbassadorSlugs = [
  'seth-feider',
  'ryan-epps',
  'chris-mitchell',
  'bdowney',
  'patrick-walters',
  'steve-rogers',
  'gwalker',
  'matt-luna',
  'joey-vanyo',
  'al-lindner',
  'troy-lindner',
  'james-lindner',
];
